module.exports = __webpack_public_path__ + "static/media/1.75-hour.0a05f6df.png";